import { getValue } from "../../../common/getValue";

export function PROVINCE_REQUEST(state) {
  state;
  state.provinces = {
    ...state.provinces,
    isLoading: true
  };
}
export function PROVINCE_SUCCESS(state, payload) {
  const { data } = payload.data
  let dataResponse = []
  data.map(item => {
    dataResponse.push({
      id: item.id || "-",
      provinceId: getValue(item, 'provinceId', "-"),
      province: getValue(item, 'province', "-"),
    });
    return item;
  });
  state;
  state.provinces = {
    ...state.provinces,
    data: dataResponse,
    status: payload.data.status,
    isLoading: false
  };
}
export function PROVINCE_ERROR(state, payload) {
  state;
  state.provinces = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function REGENCIES_REQUEST(state) {
  state;
  state.regencies = {
    ...state.regencies,
    isLoading: true
  };
}
export function REGENCIES_SUCCESS(state, payload) {
  const { data } = payload.data
  let dataResponse = []
  data.map(item => {
    dataResponse.push({
      id: item.id || "-",
      regencyId: getValue(item, 'regencyId', "-"),
      regency: getValue(item, 'regency', "-"),
    });
    return item;
  });
  state;
  state.regencies = {
    ...state.regencies,
    data: dataResponse,
    status: payload.data.status,
    isLoading: false
  };
}
export function REGENCIES_ERROR(state, payload) {
  state;
  state.regencies = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}

export function DISTRICTS_REQUEST(state) {
  state;
  state.districts = {
    ...state.districts,
    isLoading: true
  };
}
export function DISTRICTS_SUCCESS(state, payload) {
  const { data } = payload.data
  let dataResponse = []
  data.map(item => {
    dataResponse.push({
      id: item.id || "-",
      districtId: getValue(item, 'districtId', "-"),
      district: getValue(item, 'district', "-"),
    });
    return item;
  });
  state;
  state.districts = {
    ...state.districts,
    data: dataResponse,
    status: payload.data.status,
    isLoading: false
  };
}
export function DISTRICTS_ERROR(state, payload) {
  state;
  state.districts = {
    isLoading: false,
    error: true,
    errorMessage: payload
  };
}
